export function intercom(...args: any[]) {
    (window as any).Intercom?.(...args);
}
